import clientAxios from "../config/axios";
import { types } from "../types";
import { errorAlert } from "./alerts";
import { setLoading, removeLoading } from "./ui";


export const getVisas = () => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());
      const result = await clientAxios.get("/api/v1/visas");

      dispatch({
        type: types.getVisa,
        payload: result.data.visas
      })

      dispatch(removeLoading());
    } catch (error) {
      dispatch(
        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
    }
  }
}